document.addEventListener("turbo:load", () => {
  if (window.location.hash == "#sponsors") {
    $("#sponsors").modal("show");
  }
});
